var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rg-history-menu-button',{attrs:{"isMobileDevice":_vm.isMobileDevice,"tooltipSettings":{
      text: '過去履歴表示',
      position: 'right',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }